import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { CHART_TYPE_ICON_MAP, DEFAULT_CHART_ICON } from './ChartTypeToggleItemComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const CHART_TYPE_ICON_SIZE = 24;
export const ChartTypeSelectableBox = ({
  ['data-test-id']: dataTestId,
  option,
  onChartTypeChange,
  value
}) => {
  const ChartTypeIcon = option.value in CHART_TYPE_ICON_MAP ? CHART_TYPE_ICON_MAP[option.value] : DEFAULT_CHART_ICON;
  const handleClick = () => {
    onChartTypeChange({
      target: {
        value: option.value
      }
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: option.text,
    placement: "top",
    children: /*#__PURE__*/_jsx(SelectableButton, {
      "data-test-id": `${dataTestId}-${option.value}`,
      name: option.value,
      selected: option.value === value,
      height: 50,
      width: 50,
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(ChartTypeIcon, {
        size: CHART_TYPE_ICON_SIZE
      })
    }, option.value)
  });
};